import GET from "./api/GET";
import PATCH from "./api/PATCH";

export const fetchAPIKey = async () => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;

  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/api-key/get?branchId=${branchId}`
  );
  return response;
};

export const regenerateAPIKey = async () => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;

  const response = await PATCH(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/api-key/regenerate/${branchId}`,
    {}
  );
  return response;
};
